import { render } from "./ServicesComponent.vue?vue&type=template&id=109f4d00&class=services"
import script from "./ServicesComponent.vue?vue&type=script&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&lang=js"

import "./ServicesComponent.vue?vue&type=style&index=0&id=109f4d00&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__